"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueue = void 0;
/**
 * TODO: Replace this with `@react-hookz/web` implementation, when it's shipped
 */
var react_1 = require("react");
function useQueue(initialState) {
    if (initialState === void 0) { initialState = []; }
    var _a = __read((0, react_1.useState)(initialState), 2), queue = _a[0], setQueue = _a[1];
    var add = (0, react_1.useCallback)(function (value) {
        setQueue(function (q) { return __spreadArray(__spreadArray([], __read(q), false), [value], false); });
    }, []);
    var remove = (0, react_1.useCallback)(function () {
        setQueue(function (q) { return q.slice(1); });
    }, []);
    return {
        add: add,
        remove: remove,
        get first() {
            return queue[0];
        },
        get last() {
            return queue[queue.length - 1];
        },
        get size() {
            return queue.length;
        },
    };
}
exports.useQueue = useQueue;
//# sourceMappingURL=useQueue.js.map